import Navbar from "./Navbar";

function Header() {
  return (
    <header className="top-header">
      <Navbar />
    </header>
  );
}

export default Header;
